import Vue from 'vue';
import Modal from '../../src/components/modal';

let reminderPromise = null;

function showPasswordExpiryReminder() {
  if (reminderPromise) return reminderPromise;

  reminderPromise = new Promise(resolve => {
    const dialog = new Vue({
      data() {
        return { visible: true };
      },
      methods: {
        close() {
          this.visible = false;
          this.$destroy();
          if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
          reminderPromise = null;
          resolve();
        }
      },
      render(h) {
        return h(Modal, {
          class: 'xs',
          props: { title: '安全提示', showModal: this.visible, showFooter: true },
          on: { close: this.close }
        }, [
          h('section', ['您的密码长时间未更换存在安全风险，请及时更换！']),
          h('div', { slot: 'footer' }, [
            h('uButton', { on: { click: this.close } }, ['知道了'])
          ])
        ]);
      }
    }).$mount();
    document.body.appendChild(dialog.$el);
  });
  return reminderPromise;
}

// 等提醒关闭后再交给登录回调，避免原有跳转使弹窗立即消失。
export function handlePasswordExpiry(response) {
  const url = response.config && response.config.url || '';
  const data = response.data;
  const isLogin = /(?:^|\/)home\/(?:login|jumplogin|merchantLogin)\/?(?:[?#]|$)/.test(url);
  if (isLogin && data && data.result == 1 && data.model && data.model.pwdExpired === true) {
    return showPasswordExpiryReminder().then(() => response);
  }
  return response;
}



// WEBPACK FOOTER //
// ./docs/utils/passwordExpiry.js